<template>
  <el-card>
    <div v-loading="loading">
      <div class="flex-row align-center justify-between mb-16">
        <span style="font-size: 14px; color: #606266;">共 {{ alertGroupList.length }} 個群組</span>
        <el-dropdown @command="exportData" trigger="click">
          <el-button type="primary" size="small">
            匯出 <i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="xlsx">匯出 XLSX</el-dropdown-item>
            <el-dropdown-item command="csv">匯出 CSV</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="flex-row" style="gap: 16px;">
        <!-- 左側：alertGroup 列表 -->
        <div style="width: 360px; flex-shrink: 0;">
          <el-table
            :data="alertGroupList"
            border
            highlight-current-row
            @current-change="onSelectGroup"
            style="width: 100%"
          >
            <el-table-column label="Notes">
              <template slot-scope="scope">
                <span>{{ scope.row.notes || '—' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="人數" width="60" align="center">
              <template slot-scope="scope">
                {{ scope.row.userList ? scope.row.userList.length : 0 }}
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 右側：選中群組的使用者列表 -->
        <div style="flex: 1;">
          <template v-if="selectedGroup">
            <div class="mb-8" style="color: #606266; font-size: 13px;">
              <span>ID：{{ selectedGroup._id }}</span>
              <span class="ml-16">建立：{{ selectedGroup.created_at | formatDate }}</span>
            </div>
            <el-table
              :data="selectedGroup.userList"
              border
              style="width: 100%"
              empty-text="此群組尚無使用者"
            >
              <el-table-column type="index" width="50" label="#" />
              <el-table-column prop="name" label="姓名" />
              <el-table-column prop="email" label="Email" />
              <el-table-column prop="_id" label="ID" />
            </el-table>
          </template>
          <el-empty v-else description="請選擇左側的告警群組" />
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import * as XLSX from 'xlsx';

export default {
  filters: {
    formatDate(val) {
      if (!val) return '—';
      return new Date(val).toLocaleString('zh-TW');
    },
  },
  data() {
    return {
      loading: false,
      alertGroupList: [],
      selectedGroup: null,
    };
  },
  mounted() {
    this.fetchAlertGroups();
  },
  methods: {
    async fetchAlertGroups() {
      this.loading = true;
      try {
        const res = await this.$axios({
          category: 'alerts',
          method: 'get',
          apiName: 'getAllAlertGroup',
        });
        this.alertGroupList = Array.isArray(res.data) ? res.data : [];
      } catch(e) {
        console.error('fetchAlertGroups error', e);
        this.$message.error('載入告警群組失敗');
      } finally {
        this.loading = false;
      }
    },

    onSelectGroup(group) {
      this.selectedGroup = group;
    },

    buildRows() {
      const rows = [];
      for (const group of this.alertGroupList) {
        const userList = Array.isArray(group.userList) ? group.userList : [];
        if (userList.length === 0) {
          rows.push({
            群組備註: group.notes || '',
            使用者姓名: '',
          });
        } else {
          userList.forEach(user => {
            rows.push({
              群組備註: group.notes || '',
              使用者姓名: user.name || '',
            });
          });
        }
      }
      return rows;
    },

    exportData(format) {
      if (this.alertGroupList.length === 0) {
        this.$message.warning('目前無資料可匯出');
        return;
      }
      const rows = this.buildRows();
      const headers = ['群組備註', '使用者姓名'];
      const ws = XLSX.utils.json_to_sheet(rows, { header: headers });
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '告警群組');

      if (format === 'csv') {
        const csv = XLSX.utils.sheet_to_csv(ws);
        const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'alert-groups.csv';
        a.click();
        URL.revokeObjectURL(url);
      } else {
        XLSX.writeFile(wb, 'alert-groups.xlsx');
      }
      this.$message.success(`已匯出 ${format.toUpperCase()}`);
    },
  },
};
</script>
